<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo"  src="@/assets/home/7.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>星座配对</span>
    </div>
    <div class="text">
      <p>
        根据十二星座配对测试你的爱情,来分析你和另一半在基本性格上的适配度。谨供大家相处时的参考,但可不要因噎废食,看星座叫朋友哦!
      </p>
    </div>

    <div class="select-time">
      <span>男生星座</span>
      <div class="select-box" @click="clickZx1">
        <span>{{ xz1 ? xz1.title : "请选择星座" }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <div class="select-time">
      <span>女生星座</span>
      <div class="select-box" @click="clickZx2">
        <span>{{ xz2 ? xz2.title : "请选择星座" }}</span>
        <i class="iconfont icon-triangle-left"></i>
      </div>
    </div>
    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>
    <select-xz @confirm="confirmXz" :data="xz" v-model="showXz" />
    <shareBottomComp v-if="share == 1"></shareBottomComp>
</div>
  </div>
</template>

<script>
/**
@description:星座配对
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";

import selectXz from "@/components/selectXz.vue";
import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: { selectXz ,shareBottomComp,topTab},
  data() {
    return {
      showXz: false,
      currentZx: 0,
      xz: "请选择",
      xz1: "",
      xz2: "",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'星座配对',
        path:'/xzpd'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('xzpd','星座配对','','',HERF+'/image/7.png')
  },
  methods: {
    start() {
      if (this.xz1 === "") return this.Toast("男生星座未选");
      if (this.xz2 === "") return this.Toast("女生星座未选");
      this.api
        .constellationPairing({ man: this.xz1.title, woman: this.xz2.title })
        .then((res) => {
          localStorage.setItem("result", JSON.stringify(res.data));
          this.$router.push("xzpdres");
        });
    },
    clickZx1() {
      this.currentZx = 0;
      this.xz = this.xz1;
      this.showXz = true;
    },
    clickZx2() {
      this.currentZx = 1;
      this.xz = this.xz2;
      this.showXz = true;
    },
    confirmXz({ date }) {
      if (this.currentZx == 0) {
        this.xz1 = date;
      } else {
        this.xz2 = date;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 1rem 0 0.46rem;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
</style>
